import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import { Icon } from "@iconify/react";
import { servicesData } from "../../data/servicesData";
import { pageTitle } from "../../helpers/PageTitle";

const serviceIcons = {
  "ai-machine-learning": "mdi:brain",
  "web-application-development": "mdi:code-braces",
  "mobile-app-development": "mdi:cellphone",
  "cybersecurity-solutions": "mdi:shield-lock",
  "ui-ux-design": "mdi:palette",
  "seo-organic-growth": "mdi:chart-line",
  "data-analytics": "mdi:chart-bar",
  "devops-cloud-solutions": "mdi:cloud-cog",
  "digital-transformation-consulting": "mdi:lightning-bolt",
  "api-development-integration": "mdi:api",
  "low-code-no-code-development": "mdi:widgets",
};

const cardStyles = [
  {
    bg: "bg-gradient-to-br from-[#0d4f4f] to-[#0a3d3d]",
    num: "text-emerald-300",
    icon: "text-emerald-400",
    title: "text-white",
    desc: "text-emerald-100",
    link: "text-emerald-400",
    border: "border-transparent",
    tag: "",
  },
  {
    bg: "bg-white",
    num: "text-blue-600",
    icon: "text-blue-500",
    title: "text-gray-900",
    desc: "text-gray-500",
    link: "text-blue-600",
    border: "border-blue-100",
    hoverBorder: "hover:border-blue-300",
    accent: "from-blue-500 to-blue-600",
    iconBg: "bg-blue-50",
    tag: "Web Dev",
    badgeBg: "#1d4ed8",
  },
  {
    bg: "bg-white",
    num: "text-violet-600",
    icon: "text-violet-500",
    title: "text-gray-900",
    desc: "text-gray-500",
    link: "text-violet-600",
    border: "border-violet-100",
    hoverBorder: "hover:border-violet-300",
    accent: "from-violet-500 to-purple-600",
    iconBg: "bg-violet-50",
    tag: "Mobile",
    badgeBg: "#7c3aed",
  },
  {
    bg: "bg-gradient-to-br from-[#1e1b4b] to-[#312e81]",
    num: "text-indigo-300",
    icon: "text-indigo-400",
    title: "text-white",
    desc: "text-indigo-100",
    link: "text-indigo-400",
    border: "border-transparent",
    tag: "",
  },
  {
    bg: "bg-white",
    num: "text-amber-600",
    icon: "text-amber-500",
    title: "text-gray-900",
    desc: "text-gray-500",
    link: "text-amber-600",
    border: "border-amber-100",
    hoverBorder: "hover:border-amber-300",
    accent: "from-amber-500 to-orange-600",
    iconBg: "bg-amber-50",
    tag: "Design",
    badgeBg: "#d97706",
  },
  {
    bg: "bg-gradient-to-br from-[#134e4a] to-[#0f766e]",
    num: "text-teal-300",
    icon: "text-teal-400",
    title: "text-white",
    desc: "text-teal-100",
    link: "text-teal-400",
    border: "border-transparent",
    tag: "",
  },
  {
    bg: "bg-white",
    num: "text-cyan-600",
    icon: "text-cyan-500",
    title: "text-gray-900",
    desc: "text-gray-500",
    link: "text-cyan-600",
    border: "border-cyan-100",
    hoverBorder: "hover:border-cyan-300",
    accent: "from-cyan-500 to-teal-600",
    iconBg: "bg-cyan-50",
    tag: "Analytics",
    badgeBg: "#0891b2",
  },
  {
    bg: "bg-gradient-to-br from-[#0c4a6e] to-[#075985]",
    num: "text-sky-300",
    icon: "text-sky-400",
    title: "text-white",
    desc: "text-sky-100",
    link: "text-sky-400",
    border: "border-transparent",
    tag: "",
  },
  {
    bg: "bg-white",
    num: "text-orange-600",
    icon: "text-orange-500",
    title: "text-gray-900",
    desc: "text-gray-500",
    link: "text-orange-600",
    border: "border-orange-100",
    hoverBorder: "hover:border-orange-300",
    accent: "from-orange-500 to-red-600",
    iconBg: "bg-orange-50",
    tag: "Consulting",
    badgeBg: "#ea580c",
  },
  {
    bg: "bg-white",
    num: "text-indigo-600",
    icon: "text-indigo-500",
    title: "text-gray-900",
    desc: "text-gray-500",
    link: "text-indigo-600",
    border: "border-indigo-100",
    hoverBorder: "hover:border-indigo-300",
    accent: "from-indigo-500 to-blue-600",
    iconBg: "bg-indigo-50",
    tag: "API",
    badgeBg: "#4f46e5",
  },
  {
    bg: "bg-gradient-to-br from-[#701a75] to-[#86198f]",
    num: "text-fuchsia-300",
    icon: "text-fuchsia-400",
    title: "text-white",
    desc: "text-fuchsia-100",
    link: "text-fuchsia-400",
    border: "border-transparent",
    tag: "",
  },
];

export default function ServicePage() {
  pageTitle("Services");
  return (
    <main className="relative overflow-hidden bg-[#fbfdfd]">
      <div className="pointer-events-none absolute left-[-180px] top-[200px] h-[480px] w-[480px] rounded-full bg-teal-100/35 blur-3xl" />
      <div className="pointer-events-none absolute right-[-180px] top-[580px] h-[520px] w-[520px] rounded-full bg-emerald-100/35 blur-3xl" />
      <div className="pointer-events-none absolute right-[9%] top-[220px] h-28 w-28 rounded-full border border-[#F5A623]/25" />
      <div className="pointer-events-none absolute right-[11%] top-[242px] h-20 w-20 rounded-full border border-[#1b667a]/25" />

      {/* Hero */}
      <section className="relative z-10 bg-gradient-to-b from-white to-gray-50/60 px-4 pb-[60px] pt-[150px] sm:px-6 max-[991px]:pb-[50px] max-[991px]:pt-[120px]">
        {/* Decorative dots left - algo color */}
        <div
          className="pointer-events-none absolute left-[5%] top-[35%] h-36 w-52 opacity-50"
          style={{
            backgroundImage:
              "radial-gradient(#1b667a 1.5px, transparent 1.5px)",
            backgroundSize: "12px 12px",
          }}
        />
        {/* Decorative dots right - stine color */}
        <div
          className="pointer-events-none absolute right-[5%] top-[45%] h-28 w-40 opacity-50"
          style={{
            backgroundImage:
              "radial-gradient(#F5A623 1.5px, transparent 1.5px)",
            backgroundSize: "12px 12px",
          }}
        />

        <div className="mx-auto max-w-[900px] text-center">
          <div className="mb-5 inline-flex items-center gap-3">
            <div className="h-[2px] w-10 bg-gradient-to-r from-transparent to-[#1b667a]" />
            <span className="text-[11px] font-bold uppercase tracking-[3px] text-[#1b667a]">
              Our Services
            </span>
            <div className="h-[2px] w-10 bg-gradient-to-l from-transparent to-[#1b667a]" />
          </div>
          <h1 className="text-[clamp(36px,4.5vw,48px)] font-bold leading-[1.12] tracking-[-0.02em] text-gray-900">
            Empowering Your Business with{" "}
            <span className="text-[#1b667a]">Comprehensive Services</span>
          </h1>
          <p className="mx-auto mt-6 max-w-[560px] text-[16px] leading-[1.8] text-gray-500">
            From AI and cloud architecture to full-stack development and
            cybersecurity — we engineer digital solutions that scale.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="relative z-10 px-4 sm:px-6 pb-20">
        <div className="mx-auto max-w-[1200px]">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {servicesData.map((service, i) => {
              const style = cardStyles[i % cardStyles.length];
              const isDark = style.bg.includes("gradient");
              const icon = serviceIcons[service.slug] || "mdi:application";

              if (isDark) {
                return (
                  <Link
                    key={service.id}
                    to={service.href}
                    className={`group relative overflow-hidden rounded-[15px] border ${style.border} ${style.bg} shadow-[0_4px_24px_rgba(0,0,0,0.1)] transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.15)]`}
                  >
                    <div className="absolute bottom-0 left-0 right-0 h-20 opacity-30">
                      <svg
                        viewBox="0 0 300 50"
                        className="h-full w-full"
                        fill="none"
                      >
                        <path
                          d="M0,35 Q75,10 150,35 T300,35"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          opacity="0.4"
                          className={style.icon}
                        />
                        <path
                          d="M0,42 Q75,17 150,42 T300,42"
                          stroke="currentColor"
                          strokeWidth="1"
                          opacity="0.2"
                          className={style.icon}
                        />
                      </svg>
                    </div>
                    <div className="relative px-6 pt-6 pb-20">
                      <span className={`text-[36px] font-bold ${style.num}`}>
                        {service.number}
                      </span>
                      <div className="absolute top-6 right-6">
                        <div className="flex h-[56px] w-[56px] items-center justify-center rounded-full bg-white/10">
                          <Icon
                            icon={icon}
                            className={`h-7 w-7 ${style.icon}`}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="px-6 pb-6">
                      <h3
                        className={`mb-2.5 text-[20px] font-bold leading-tight ${style.title}`}
                      >
                        {service.title}
                      </h3>
                      <p
                        className={`mb-4 text-[15px] leading-[1.7] ${style.desc}`}
                      >
                        {service.tagline.length > 120
                          ? service.tagline.substring(0, 120) + "..."
                          : service.tagline}
                      </p>
                      <div
                        className={`flex items-center gap-2 text-[14px] font-semibold ${style.link} group-hover:gap-3 transition-all duration-300`}
                      >
                        Learn More <FiArrowRight className="h-4 w-4" />
                      </div>
                    </div>
                  </Link>
                );
              }

              return (
                <Link
                  key={service.id}
                  to={service.href}
                  className={`group relative overflow-hidden rounded-[15px] border ${style.border} ${style.hoverBorder} bg-white p-7 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)]`}
                >
                  <div
                    className={`absolute -right-10 -top-10 h-28 w-28 rounded-full bg-gradient-to-br ${style.accent} opacity-10 transition-all duration-500 group-hover:scale-[2.5] group-hover:opacity-20`}
                  />
                  <div
                    className={`mb-5 flex h-14 w-14 items-center justify-center rounded-2xl ${style.iconBg} text-2xl shadow-sm transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3`}
                  >
                    <Icon icon={icon} className={`h-7 w-7 ${style.icon}`} />
                  </div>
                  <h3 className="mb-2.5 text-[22px] font-bold tracking-[-0.01em] text-gray-900">
                    {service.title}
                  </h3>
                  <p className="mb-4 text-[16px] leading-[1.7] text-gray-500">
                    {service.tagline.length > 120
                      ? service.tagline.substring(0, 120) + "..."
                      : service.tagline}
                  </p>
                  <span
                    className="inline-flex items-center rounded-full px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white"
                    style={{ backgroundColor: style.badgeBg }}
                  >
                    {style.tag}
                  </span>
                  <div
                    className={`absolute bottom-0 left-0 h-[3px] w-0 bg-gradient-to-r ${style.accent} transition-all duration-500 group-hover:w-full`}
                  />
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative z-10 px-4 sm:px-6 pb-20">
        <div className="relative mx-auto max-w-[1000px] overflow-hidden rounded-[24px] border border-gray-100 bg-white px-8 py-16 shadow-[0_8px_40px_rgba(0,0,0,0.06)] sm:px-16">
          {/* Left/right gradient lines */}
          <div className="pointer-events-none absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-[#1b667a]/20 to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 h-full w-1 bg-gradient-to-b from-transparent via-[#F5A623]/20 to-transparent" />
          {/* Dots pattern */}
          <div
            className="pointer-events-none absolute left-[3%] top-[8%] h-24 w-32 opacity-[0.08]"
            style={{
              backgroundImage: "radial-gradient(#1b667a 1px, transparent 1px)",
              backgroundSize: "10px 10px",
            }}
          />
          <div
            className="pointer-events-none absolute bottom-[8%] right-[3%] h-20 w-28 opacity-[0.08]"
            style={{
              backgroundImage: "radial-gradient(#F5A623 1px, transparent 1px)",
              backgroundSize: "10px 10px",
            }}
          />
          {/* Circles */}
          <div className="pointer-events-none absolute -right-8 -top-8 h-32 w-32 rounded-full border border-[#1b667a]/8" />
          <div className="pointer-events-none absolute -bottom-6 -left-6 h-24 w-24 rounded-full border border-[#F5A623]/8" />
          <div className="pointer-events-none absolute right-[12%] bottom-[20%] h-12 w-12 rounded-full border border-gray-100" />
          <div className="pointer-events-none absolute left-[10%] top-[25%] h-8 w-8 rounded-full border border-gray-100" />

          <div className="relative text-center">
            <h2 className="mb-5 text-[clamp(28px,4vw,42px)] font-bold leading-[1.15] text-gray-900">
              Let's Build Something{" "}
              <span className="text-[#1b667a]">Great Together</span>
            </h2>
            <p className="mx-auto mb-10 max-w-[520px] text-[16px] leading-[1.8] text-gray-500">
              Ready to transform your digital infrastructure? Get in touch and
              let's discuss how we can help you scale.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                to="/contact"
                className="group inline-flex items-center gap-2 rounded-[15px] bg-[#1b667a] px-8 py-3.5 text-[14px] font-semibold text-white shadow-lg shadow-[#1b667a]/20 transition-all duration-300 hover:bg-[#155568] hover:shadow-xl hover:scale-[1.02]"
              >
                Send Message
                <FiArrowRight
                  className="transition-transform duration-300 group-hover:translate-x-1"
                  size={16}
                />
              </Link>
              <Link
                to="/service"
                className="inline-flex items-center gap-2 rounded-[15px] border border-gray-200 bg-white px-8 py-3.5 text-[14px] font-semibold text-gray-700 transition-all duration-300 hover:border-gray-300 hover:bg-gray-50"
              >
                View All Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
